import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import LoginForm from './components/LoginForm';
import TrustSignals from './components/TrustSignals';
import Image from '../../components/AppImage';

const Login = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('login.metaTitle')}</title>
        <meta name="description" content={t('login.metaDescription')} />
      </Helmet>
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 sm:px-6 md:px-8 py-6 sm:py-8 md:py-12">
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 max-w-7xl mx-auto">
            <div className="flex items-center justify-center">
              <div className="w-full max-w-md px-4 sm:px-0">
                <div className="text-center mb-6 sm:mb-8">
                  <Image
                    src="/assets/images/S-2-1766376617209.jpeg"
                    alt={`${t('common.appName')} logo - Medical referral platform powered by iRefer guidelines with geometric blue and purple gradient design`}
                    className="h-12 sm:h-14 md:h-16 w-auto mx-auto mb-4" />

                  <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-foreground">{t('login.welcomeBack')}</h2>
                  <p className="text-sm sm:text-base text-muted-foreground mt-2">{t('login.subtitle')}</p>
                </div>
                <LoginForm />
              </div>
            </div>

            <div className="hidden lg:flex flex-col justify-center">
              <div className="clinical-card p-6 md:p-8">
                <TrustSignals />

                <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-border">
                  <div className="relative h-48 sm:h-56 md:h-64 rounded-lg overflow-hidden bg-muted">
                    <Image
                      src="https://images.unsplash.com/photo-1716802943807-7f719e0e0f76"
                      alt="Modern medical imaging workstation with multiple diagnostic monitors displaying CT and MRI scans in a professional clinical environment"
                      className="w-full h-full object-cover" />

                    <div className="absolute inset-0 bg-gradient-to-t from-background/90 to-transparent flex items-end p-4 md:p-6">
                      <div>
                        <p className="text-sm md:text-base font-semibold text-foreground">{t('login.evidenceBasedMedicine')}</p>
                        <p className="text-xs md:text-sm text-muted-foreground mt-1">
                          {t('login.evidenceBasedDesc')}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-6 grid grid-cols-3 gap-3 md:gap-4">
                  <div className="text-center p-3 bg-muted/50 rounded-lg">
                    <p className="text-xl md:text-2xl font-bold text-primary">98%</p>
                    <p className="text-xs text-muted-foreground mt-1">{t('login.accuracyRate')}</p>
                  </div>
                  <div className="text-center p-3 bg-muted/50 rounded-lg">
                    <p className="text-xl md:text-2xl font-bold text-primary">50K+</p>
                    <p className="text-xs text-muted-foreground mt-1">{t('login.clinicians')}</p>
                  </div>
                  <div className="text-center p-3 bg-muted/50 rounded-lg">
                    <p className="text-xl md:text-2xl font-bold text-primary">24/7</p>
                    <p className="text-xs text-muted-foreground mt-1">{t('login.support')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 sm:mt-12 text-center px-4">
            <p className="text-xs text-muted-foreground">
              &copy; {new Date()?.getFullYear()} {t('common.appName')}. {t('common.allRightsReserved')} | {t('common.hipaaCompliant')} | {t('common.isoCompliant')}
            </p>
          </div>
        </div>
      </div>
    </>);

};

export default Login;